import type { FormData } from '../types/form';

export const initialFormData: FormData = {
  applicant_role: 'patient',
  first_name: '',
  last_name: '',
  phone_number: '',
  email: '',
  reporter_first_name: '',
  reporter_last_name: '',
  reporter_phone_number: '',
  reporter_email: '',
  contact_preference: 'call',
  date_of_birth: '',
  incident_date: '',
  occupant_list: [],
  another_vehicle_involved: 'no',
  vehicle_insurance_name: '',
  vehicle_policy_number: '',
  vehicle_claim_number: '',
  auto_insurance: '',
  policy_number: '',
  claim_number: '',
  health_insurance: '',
  additional_information: '',
};
